exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.login_full_name {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 5px;\n}\n.login_full_name a {\n  font-size: 14px;\n  font-weight: 600;\n}\n", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/home/HomeUserTopDesktop.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB","file":"HomeUserTopDesktop.vue","sourcesContent":["\n.login_full_name {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 5px;\n}\n.login_full_name a {\n  font-size: 14px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-640c4d88","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/HomeUserTopDesktop.vue
// module id = f/d7
// module chunks = 87